import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
Vue.use(Vuex);

import * as getters from "./getters";
import * as actions from "./actions";
import * as mutations from "./mutations";

const state = {
  token: Cookies.get("token") || "", // token
  local: "zh",
  // user: Cookies.get("user") ? JSON.parse(Cookies.get("user")) : {}, // 用户
};
const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js